module.exports = __webpack_public_path__ + "img/rf.d29e16a4.svg";